/* GMU carousel (T2): scroll-snap track + round side arrows centred on the images.
   Arrows hide at start / end, each click or arrow key scrolls by one card. No library. */
(function () {
  if (customElements.get('gmu-carousel')) return;

  class GmuCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gmu-track');
      this.prev = this.querySelector('.gmu-sarrow--prev');
      this.next = this.querySelector('.gmu-sarrow--next');
      if (!this.track || !this.prev || !this.next) return;

      this.update = this.update.bind(this);
      this.prev.addEventListener('click', () => { if (this.prev.getAttribute('aria-disabled') !== 'true') this.go(-1); });
      this.next.addEventListener('click', () => { if (this.next.getAttribute('aria-disabled') !== 'true') this.go(1); });
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.track.addEventListener('keydown', (e) => {
        if (e.target !== this.track) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
      });
      // rAF: update() changes layout (--gmu-car-mid), doing it inside the observer callback raised "ResizeObserver loop" errors in WebKit.
      this.ro = new ResizeObserver(() => requestAnimationFrame(this.update));
      this.ro.observe(this.track);
      this.track.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.update, { once: true });
      });
      this.update();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    step() {
      const first = this.track.firstElementChild;
      if (!first) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    go(dir) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: this.step() * dir, behavior: reduce ? 'auto' : 'smooth' });
    }

    update() {
      const media = this.track.querySelector('.gmu-card__media, [data-gmu-media]');
      if (media) this.style.setProperty('--gmu-car-mid', media.offsetHeight / 2 + 'px');
      const t = this.track;
      const atStart = t.scrollLeft < 4;
      const atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
      this.toggle(this.prev, atStart);
      this.toggle(this.next, atEnd);
    }

    // Hidden arrows get aria-disabled (not disabled) so a focused arrow keeps focus at the ends.
    toggle(btn, off) {
      btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    }
  }

  customElements.define('gmu-carousel', GmuCarousel);
})();
